
/**
 * Utilitaire de logging qui désactive les logs en production
 * mais les affiche en développement
 */

// Déterminer si nous sommes en production
const isProduction = process.env.NODE_ENV === 'production';

/**
 * Logger qui n'affiche les logs qu'en environnement de développement
 */
const logger = {
  log: (...args: any[]) => {
    if (!isProduction) {
      console.log(...args);
    }
  },
  
  info: (...args: any[]) => {
    if (!isProduction) {
      console.info(...args);
    }
  },
  
  warn: (...args: any[]) => {
    // On garde les warnings même en production car ils peuvent être importants
    console.warn(...args);
  },
  
  error: (...args: any[]) => {
    // On garde les erreurs même en production car elles sont importantes
    console.error(...args);
  },
  
  debug: (...args: any[]) => {
    if (!isProduction) {
      console.debug(...args);
    }
  }
};

export default logger;
